import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 一覧照会検索方法 */
enum ListInquirySearchMethod {
  specific = '1',
  detail = '2',
}

const nameConfig = {
  specific: new Map([
    [Locale.ja, '特定の条件で探す'],
    [Locale.en, 'Search with Specific Conditions'],
  ]),
  detail: new Map([
    [Locale.ja, '詳細な条件を指定して探す'],
    [Locale.en, 'Search with Detailed Conditions'],
  ]),
};

const toEnum = rawValueToEnum(ListInquirySearchMethod, ListInquirySearchMethod.specific);
const toDisplay = enumToName(ListInquirySearchMethod, nameConfig);
const toDisplayWithPrefix = enumToName(ListInquirySearchMethod, nameConfig, { prefix: true });

export const listInquirySearchMethod = {
  enum: ListInquirySearchMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ListInquirySearchMethod };
